export default __webpack_public_path__ + "static/media/blue_2.f909b03d.png";